import { useMemo, useState, useEffect } from 'react';

import { Cookie } from '@/tscapi/utils/cookie';

import { useAuthenticated } from './useAuthenticated';
import { useCart, useRemoveDonation } from './useCart';

export const useTaxProvince = () => {
    const isAuthenticated = useAuthenticated();
    const [defaultTax, setDefaultTax] = useState('ON');
    const [taxProvince, setTaxProvince] = useState('ON');
    const [taxProvinceId, setTaxProvinceId] = useState(8);
    const { data, isLoading } = useCart(isAuthenticated);
    const cookie: Cookie = new Cookie();

    const setProvinceId = (ID) => {
        if (ID) {
            setTaxProvinceId(ID);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            if (data?.ShippingAddress != null) {
                setTaxProvince(data?.ShippingAddress.State);
                setDefaultTax(data?.ShippingAddress.State);
            } else {
                if (data?.Buyer?.BillingAddress?.State != null) {
                    setTaxProvince(data?.Buyer?.BillingAddress?.State);
                    setDefaultTax(data?.Buyer?.BillingAddress?.State);
                } else {
                    setTaxProvince('ON');
                    setDefaultTax('ON');
                }
            }
        } else {
            setTaxProvince('ON');
            setDefaultTax('ON');
        }
    }, [data, cookie.CartProvince, isAuthenticated]);

    return { taxProvince, setTaxProvince, defaultTax };
};
